export default theme => ({
  dashboard_content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(6),
    height: "100%",
    overflow: "auto",
    marginTop: 80,
    marginBottom: 80,
  },
});
